import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { Activity, ActivityText } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../../modules/angular.module';
import { LanguageTabsComponent } from './language-tabs/language-tabs.component';

@Component({
	selector: 'app-header-instructions',
	standalone: true,
	imports: [AngularModule, LanguageTabsComponent],
	templateUrl: './header-instructions.component.html',
	styleUrl: './header-instructions.component.scss',
})
export class HeaderInstructionsComponent {
	@Output('onClose') public onClose: any = new EventEmitter<void>();
	@Input('activity') public activity: Activity | undefined;
	public activityText: ActivityText | undefined;

	ngOnChanges(changes: SimpleChanges) {
		if (changes['activity'] && changes['activity'].currentValue) {
			this.activity = changes['activity'].currentValue;
			this.activityText = this.activity?.active_text;
		}
	}

	public onLanguageChange(ActivityText: ActivityText): void {
		this.activityText = ActivityText;
	}
}
